module.exports = __webpack_public_path__ + "static/media/hippo.bc5a0ffb.jpeg";